/* eslint-disable no-param-reassign */
// eslint-disable-next-line default-param-last
const transformObject = (obj = {}, cb) => Object.keys(obj).reduce((acc, key) => {
  cb(acc, key, obj[key]);
  return acc;
}, {});

export const parseStringToBool = (obj = {}) => transformObject(obj, (newObj, key, value) => {
  if (typeof value === 'object') newObj[key] = parseStringToBool(value);
  else if (value === 'true' || value === 'false') newObj[key] = value === 'true';
  else newObj[key] = value;
  return newObj;
});

export default transformObject;
